import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { Box, Chip, useTheme } from "@mui/material";

export const State = {
  requested: "Requested",
  upcoming: "Upcoming",
  active: "Active",
  expired: "Expired",
  canceled: "Canceled",
  archived: "Archived",
} as const;

export type StatusChipCellProps = {
  state: (typeof State)[keyof typeof State];
  displayDot?: boolean;
};

export const StatusChipCell = ({
  state,
  displayDot = true,
}: StatusChipCellProps) => {
  const { colors, customSpacing, radius, customFontWeight } = useTheme();
  const { t } = useResource();

  const dotColor =
    state === State.active
      ? colors.text.success
      : state === State.canceled || state === State.expired
        ? colors.text.warning
        : colors.text.primary;

  return (
    <Chip
      label={t(Resources.States[state])}
      size="small"
      icon={
        displayDot ? (
          <Box
            sx={{
              width: customSpacing.md,
              height: customSpacing.md,
              borderRadius: radius.full,
              backgroundColor: dotColor,
            }}
          />
        ) : undefined
      }
      sx={{
        textTransform: "capitalize",
        fontWeight: customFontWeight.medium,
        color: dotColor,
        backgroundColor:
          state === State.active
            ? colors.background.successTertiary
            : state === State.canceled || state === State.expired
              ? colors.background.warningTertiary
              : state === State.upcoming || state === State.archived
                ? colors.background.tertiary
                : colors.background.primary,
        border:
          state === State.requested
            ? `1px solid ${colors.border.primary}`
            : "none",
        "& .MuiChip-icon": {
          marginLeft: customSpacing.md,
          marginRight: customSpacing.none,
        },
      }}
    />
  );
};
